// Real client projects built by InnerSource.ai.
// Thumbnails are live screenshots via WordPress mShots (no API key required).
const shot = (url, w = 1200, h = 900) =>
  `https://s.wp.com/mshots/v1/${encodeURIComponent(url)}?w=${w}&h=${h}`;

export const projects = [
  {
    id: "global-controls",
    title: "Global Controls Inc.",
    category: "Industrial",
    industry: "Energy & Automation",
    url: "https://gci-safety-hub.emergent.host",
    thumbnail: shot("https://gci-safety-hub.emergent.host"),
    tags: ["Corporate Site", "Energy", "Safety Hub"],
    description:
      "A turnkey digital home for an industrial electrical & automation firm serving oil, gas and renewable energy. We translated complex E&I construction, PLC programming and fabrication services into a clean, safety-forward experience that builds trust with enterprise buyers.",
  },
  {
    id: "giusti-wall-tech",
    title: "Giusti Wall Tech",
    category: "Industrial",
    industry: "Construction Tech",
    url: "https://build-preview-launch.emergent.host",
    thumbnail: shot("https://build-preview-launch.emergent.host"),
    tags: ["Cinematic", "Storytelling", "Brand Site"],
    description:
      "A cinematic brand experience for Giusti Wall Tech, presented as two distinct concepts — a clean, editorial professional site and an immersive video-led story. Rich scroll animations and tasteful motion turn a construction-technology brand into a premium, memorable showcase.",
  },
  {
    id: "centurion",
    title: "Centurion Matting Products",
    category: "Industrial",
    industry: "Manufacturing",
    url: "https://centurion-build-1.emergent.host",
    thumbnail: shot("https://centurion-build-1.emergent.host"),
    tags: ["Manufacturing", "Wholesale", "B2B"],
    description:
      "A direct, no-nonsense B2B site for a manufacturer of heavy-duty matting for oil & gas, power and infrastructure projects. Manufacturer-direct pricing and custom build capability are front and center, engineered to drive procurement enquiries on time and on budget.",
  },
  {
    id: "lake-sylvan",
    title: "1132 Lake Sylvan Place",
    category: "Real Estate",
    industry: "Luxury Property",
    url: "https://lakesylvanplace.com",
    thumbnail: shot("https://lakesylvanplace.com"),
    tags: ["Property Listing", "Luxury", "Single Page"],
    description:
      "A cinematic single-property showcase for a fully rebuilt Calgary residence. Open-concept living, custom white-oak millwork and premium finishes are spotlighted through immersive imagery and a refined, scroll-driven story that sells the home before the first viewing.",
  },
  {
    id: "spire-group",
    title: "Spire Group",
    category: "Corporate",
    industry: "Healthcare Real Estate",
    url: "https://www.spiregrp.com",
    thumbnail: shot("https://www.spiregrp.com"),
    tags: ["Consulting", "Healthcare", "Lead Gen"],
    description:
      "A polished brand presence for North America's leading healthcare real estate consultancy. Decades of transaction expertise are presented through a confident, data-driven layout designed to convert healthcare professionals into qualified consulting leads.",
  },
];

export const categories = ["All", "Industrial", "Corporate", "Real Estate"];
